import Div from './Div';
import Text from './Text';

export { default as Div } from './Div';
export { default as Text } from './Text';

const ScrollReveal = { Div, Text };
export default ScrollReveal;